import React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';

import { Video, CourseDocument } from '@edx/graphql/generated';
import { translateVideoLevel } from '@edx/helpers/video-levels';
import { MediaGrid, GridItemProps } from '@edx/components/media-grid';
import { getStaticApolloClient } from '@edx/helpers/apollo';
import { PastDueModal } from '@edx/components/past-due-modal';
import { Title } from '@edx/components/typography';

export const getStaticProps: GetStaticProps = async () => {
  const { apolloClient } = await getStaticApolloClient();

  const { data } = await apolloClient.query({ query: CourseDocument, variables: { slug: 'consejos' } });

  const { metaDescription, metaTitle, schemaOrg, videos } = data.course;
  const items = videos.map(({ name, resourcePath, level, description, imageUrl, duration, isPublic }: Video) => ({
    title: name,
    subtitle: translateVideoLevel(level),
    resourcePath,
    description,
    imageUrl,
    duration,
    ...(isPublic && { badge: 'Gratis' }),
  }));

  return { props: { metaDescription, metaTitle, schemaOrg: schemaOrg ?? null, items: items.reverse() } };
};

type Props = {
  metaDescription?: string;
  metaTitle?: string;
  schemaOrg?: string;
  items: GridItemProps[];
};

const Tips: React.FC<Props> = ({ metaDescription, metaTitle, schemaOrg, items }) => (
  <>
    <Head>
      {metaTitle && <title key="title">{metaTitle}</title>}

      {metaDescription && <meta key="description" name="description" content={metaDescription} />}

      {/* Open Graph */}
      {metaTitle && <meta key="og:title" property="og:title" content={metaTitle} />}
      {metaDescription && <meta key="og:description" property="og:description" content={metaDescription} />}

      {schemaOrg && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaOrg }} />}
    </Head>

    <div className="max-w-6xl mx-auto px-4 md:px-10 pt-4 pb-20 md:pt-4">
      <Title tag="h1" className="mt-5 text-white">
        Consejos
      </Title>

      {Boolean(items?.length) && <MediaGrid items={items} className="mt-15" />}
    </div>

    <PastDueModal />
  </>
);

export default Tips;
